import { Center } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./icon.module.scss";
import type { IconFactory, IProps, ISkeletonProps } from "./icon.types";
import classnames from "classnames";
import { Skeleton } from "../skeleton";
import { componentWrapper } from "../../utilities";

/**
 * Icon component.
 * @param props.size Icon size.
 * @param props.icon Icon definition; if omitted, the component renders nothing.
 * @returns {JSX.Element | null} Icon component, or null when no icon is provided.
 */
const Icon = componentWrapper<IconFactory, IProps>("Icon", ({ size, className, icon, ...props }, ref) => {
    if (icon == null) {
        return null;
    }

    return (
        <Center ref={ref}>
            <FontAwesomeIcon
                fixedWidth
                data-size={size}
                className={classnames(styles["icon"], className)}
                icon={icon}
                {...props}
            />
        </Center>
    );
});

/**
 * Icon skeleton component.
 * @param props.size Icon size.
 * @returns {JSX.Element} Icon skeleton component.
 */
const IconSkeleton = ({ size, className, ...props }: ISkeletonProps) => {
    return <Skeleton circle data-size={size} className={styles["skeleton"]} {...props} />;
};

Icon.Skeleton = IconSkeleton;

export { Icon, IconSkeleton };
